export default [
    { //债权融资需求列表
        path: '/debtManagement/productDemandList',
        name:'debtManagementProductDemandList',
        meta: { title: '债权融资需求列表'},
        component: () => import('../../views/debtManagement/productDemandList.vue')
    },
    { //债权融资需求列表-推荐债权产品
        path: '/debtManagement/productDemandRecommend',
        name:'debtManagementProductDemandRecommend',
        meta: { title: '债权融资需求列表-推荐债权产品'},
        component: () => import('../../views/debtManagement/productDemandRecommend.vue')
    },
    { //债权融资需求列表-详情
        path: '/debtManagement/productDemandDetail',
        name:'debtManagementProductDemandRecommend',
        meta: { title: '债权融资需求列表-详情'},
        component: () => import('../../views/debtManagement/productDemandDetail.vue')
    },
    { //债权产品列表
        path: '/debtManagement/productList',
        name:'debtManagementProductList',
        meta: { title: '债权产品列表'},
        component: () => import('../../views/debtManagement/productList.vue')
    },
    { //债权产品明细
        path: '/debtManagement/productDetail',
        name:'debtManagementProductDetail',
        meta: { title: '债权产品明细'},
        component: () => import('../../views/debtManagement/productDetail.vue')
    },
    { //融资租赁公司列表
        path: '/debtManagement/companyList',
        name:'debtManagementCompanyList',
        meta: { title: '融资租赁公司列表'},
        component: () => import('../../views/debtManagement/companyList.vue')
    },
    { //融资租赁公司明细
        path: '/debtManagement/companyDetail',
        name:'debtManagementCompanyDetail',
        meta: { title: '融资租赁公司明细'},
        component: () => import('../../views/debtManagement/companyDetail.vue')
    },
    { //融资租赁申请列表
        path: '/debtManagement/applyList',
        name:'debtManagementApplyList',
        meta: { title: '融资租赁申请列表'},
        component: () => import('../../views/debtManagement/applyList.vue')
    },
    { //融资租赁公司详情
        path: '/debtManagement/applyDetail',
        name:'debtManagementApplyDetail',
        meta: { title: '融资租赁公司详情'},
        component: () => import('../../views/debtManagement/applyDetail.vue')
    },
    { //融资租赁申请详情
      path: '/debtManagement/applyList/detail',
      name:'debtManagementApplyListDetail',
      meta: { title: '融资租赁申请详情'},
      component: () => import('../../views/debtManagement/applyListDetail.vue')
  },
]